import React, {
    Fragment,
    useState
} from 'react';


import {
    useDispatch,
    useSelector
} from 'react-redux';


import Modal
    from 'react-modal';


import {
    objetivosNuevosAction
} from '../../actions/objetivosActions';


import {
    setearAlerta,
    ocultarAlertaAction
} from '../../actions/alertaActions';


import useConfigAuth
    from '../../Hooks/useConfigAuth';


// css
import {

    BotonNuevoObjetivo,

    ContenidoModalObjetivo,
    TituloModalObjetivo,
    TextoModalObjetivo,

    LabelModalObjetivo,
    InputModalObjetivo,

    AccionesModalObjetivo,
    BotonCancelarObjetivo,
    BotonGuardarObjetivo,

    MensajeModalObjetivo,

    estilosModalObjetivo

} from '../Css/StyledObjetivos';



Modal.setAppElement(
    '#root'
);



const ObjetivosNuevos = (
    props
) => {


    const {
        id,
        seccion
    } = props.seccion;


    const [
        config
    ] = useConfigAuth();


    const [
        modalIsOpen,
        setModalIsOpen
    ] = useState(
        false
    );


    const [
        nombreObjetivo,
        setNombreObjetivo
    ] = useState(
        ''
    );


    const id_paciente =
        useSelector(
            (state) =>
                state.usuario.id_paciente
        );


    const cargando =
        useSelector(
            (state) =>
                state.estado.cargando
        );


    const error =
        useSelector(
            (state) =>
                state.estado.error
        );


    const alerta =
        useSelector(
            (state) =>
                state.alertas.alerta
        );


    const dispatch =
        useDispatch();



    /*
    ====================================
    CERRAR MODAL
    ====================================
    */

    const cerrarModal =
        () => {


            setNombreObjetivo(
                ''
            );


            dispatch(
                ocultarAlertaAction()
            );


            setModalIsOpen(
                false
            );

        };



    /*
    ====================================
    CREAR OBJETIVO
    ====================================
    */

    const submitObjetivosNuevos =
        e => {


            e.preventDefault();


            if (
                nombreObjetivo.trim() ===
                ''
            ) {


                const alerta = {

                    msg:
                        'El objetivo es obligatorio'

                };


                dispatch(
                    setearAlerta(
                        alerta
                    )
                );


                return;

            }


            dispatch(
                ocultarAlertaAction()
            );


            const informacion = {

                config,

                payload: {

                    nombreObjetivo,

                    id_seccion_objetivo:
                        id,

                    seccion_objetivo:
                        seccion,

                    id_paciente

                }

            };


            dispatch(
                objetivosNuevosAction(
                    informacion
                )
            );


            setNombreObjetivo(
                ''
            );


            setModalIsOpen(
                false
            );

        };



    return (

        <Fragment>


            <BotonNuevoObjetivo

                type="button"

                title={
                    "Crear objetivo nuevo"
                }

                onClick={
                    () =>
                        setModalIsOpen(
                            true
                        )
                }

            >

                +

            </BotonNuevoObjetivo>


            <Modal

                isOpen={
                    modalIsOpen
                }

                onRequestClose={
                    cerrarModal
                }

                style={
                    estilosModalObjetivo
                }

                contentLabel={
                    "Crear objetivo nuevo"
                }

            >


                <form

                    onSubmit={
                        submitObjetivosNuevos
                    }

                >


                    <ContenidoModalObjetivo>


                        <TituloModalObjetivo>

                            Crear objetivo en {
                                seccion
                            }

                        </TituloModalObjetivo>


                        <TextoModalObjetivo>

                            Creá un objetivo que puedas
                            reutilizar con otros pacientes.

                            {' '}

                            Tené en cuenta que, una vez
                            agregado, no podrá editarse
                            ni eliminarse.

                        </TextoModalObjetivo>


                        <LabelModalObjetivo

                            htmlFor={
                                "nombreObjetivo"
                            }

                        >

                            Nombre del objetivo

                        </LabelModalObjetivo>


                        <InputModalObjetivo

                            id={
                                "nombreObjetivo"
                            }

                            type="text"

                            placeholder={
                                "Ej.: Fluidez lectora"
                            }

                            name={
                                "nombreObjetivo"
                            }

                            value={
                                nombreObjetivo
                            }

                            autoFocus

                            onChange={
                                e =>
                                    setNombreObjetivo(
                                        e.target.value
                                    )
                            }

                        />


                        {
                            alerta
                                ?

                                <MensajeModalObjetivo
                                    error={
                                        true
                                    }
                                >

                                    {
                                        alerta.msg
                                    }

                                </MensajeModalObjetivo>

                                :

                                null
                        }


                        {
                            error
                                ?

                                <MensajeModalObjetivo
                                    error={
                                        true
                                    }
                                >

                                    Hubo un error al crear el objetivo.

                                </MensajeModalObjetivo>

                                :

                                null
                        }


                        {
                            cargando
                                ?

                                <MensajeModalObjetivo>

                                    Guardando...

                                </MensajeModalObjetivo>

                                :

                                null
                        }


                        <AccionesModalObjetivo>


                            <BotonCancelarObjetivo

                                type="button"

                                onClick={
                                    cerrarModal
                                }

                            >

                                Cancelar

                            </BotonCancelarObjetivo>


                            <BotonGuardarObjetivo

                                type="submit"

                                disabled={
                                    cargando
                                }

                            >

                                Agregar objetivo

                            </BotonGuardarObjetivo>


                        </AccionesModalObjetivo>


                    </ContenidoModalObjetivo>


                </form>


            </Modal>


        </Fragment>

    );

};


export default ObjetivosNuevos;